import React from 'react';
import { Clock, Calendar, CalendarDays, Activity } from 'lucide-react';
import { pmToAqi, getAqiCategory } from '../utils/airQualityUtils';

const CompactMetrics = ({ statistics }) => {
  const metrics = {
    current: pmToAqi(statistics?.countywide?.hour?.adjustedAverage || 0),
    hour: pmToAqi(statistics?.countywide?.hour?.adjustedAverage || 0),
    day: pmToAqi(statistics?.countywide?.day?.adjustedAverage || 0),
    week: pmToAqi(statistics?.countywide?.week?.adjustedAverage || 0)
  };

  const lastUpdated = statistics?.metadata?.computedAt ? 
    new Date(statistics.metadata.computedAt).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit'
    }) : '--';

  const MetricItem = ({ value, label, icon: Icon }) => {
    const { color, category } = getAqiCategory(value);
    
    return (
      <div className="flex items-center gap-2">
        <Icon size={16} className="text-gray-500" />
        <div className="flex items-baseline gap-2">
          <span className="text-sm text-gray-600">{label}:</span>
          <span className="text-lg font-semibold">{Math.round(value)}</span>
          <span className="text-xs" style={{ color }}>
            {category}
          </span>
        </div>
      </div>
    );
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-lg font-semibold">County-wide AQI Averages</h3>
        <div className="text-sm text-gray-500 flex items-center gap-2">
          <Clock size={14} />
          Last Updated: {lastUpdated}
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-3">
        <MetricItem value={metrics.current} label="Current" icon={Activity} />
        <MetricItem value={metrics.hour} label="Hour Avg" icon={Clock} />
        <MetricItem value={metrics.day} label="Day Avg" icon={Calendar} />
        <MetricItem value={metrics.week} label="Week Avg" icon={CalendarDays} />
      </div>
      
      <div className="text-xs text-gray-500 mt-3">
        {statistics?.metadata?.readingCount || 0} readings from {statistics?.metadata?.locationCount || 0} locations
      </div>
    </div>
  );
};

export default CompactMetrics;